<template>
    <div class="global-background">
        <transition name="switch">
            <div
                v-show="showImage1"
                class="global-background__item"
                :style="{ backgroundImage: background1, zIndex: image1ZIndex }"
            ></div>
        </transition>
        <transition name="switch">
            <div
                v-show="showImage2"
                class="global-background__item"
                :style="{ backgroundImage: background2, zIndex: image2ZIndex }"
            ></div>
        </transition>
    </div>
</template>

<script>
function wrapBackground(src) {
    return `url(${src})`;
}

function loadImage(src) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;

        if (img.complete) resolve();

        img.onload = resolve;
        img.onerror = reject;
    });
}

export default {
    name: 'GlobalBackground',

    data() {
        return {
            background1: '',
            background2: '',

            // 使用奇偶变化次数来切换两张背景图的显隐
            times: -1
        };
    },

    computed: {
        background() {
            return this.$store.state.desk.background;
        },

        showImage1() {
            return this.times % 2 === 0;
        },
        showImage2() {
            return this.times % 2 === 1;
        },
        image1ZIndex() {
            return this.showImage1 ? 2 : 1;
        },
        image2ZIndex() {
            return this.showImage2 ? 2 : 1;
        }
    },

    watch: {
        background: {
            immediate: true,
            handler(image) {
                this.nextShow(image);
            }
        }
    },

    methods: {
        async nextShow(src) {
            try {
                await loadImage(src);

                if (this.times % 2 === 0) {
                    this.background2 = wrapBackground(src);
                } else {
                    this.background1 = wrapBackground(src);
                }

                this.times++;
            } catch (err) {
                // ignore
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../styles/var';

.global-background {
    background-color: $desk-background-color;

    &__item {
        background-size: cover;
        background-position: center center;
        position: absolute;
        inset: 0;
    }
}

.switch-enter-active,
.switch-leave-active {
    transition: opacity 1s ease-in-out;
}

.switch-enter,
.switch-leave-to {
    opacity: 0;
}
</style>
